const articleTypes = {
    LEVIA: 'LEVIA',
    ILUMA_I2: 'ILUMA_I2',
    BENEFITS: 'BENEFITS',
    EXPLORE_TEREA: 'EXPLORE_TEREA',
    EXPLORE_LEVIA: 'EXPLORE_LEVIA',
    EXPLORE_DELIA: 'EXPLORE_DELIA',
};

export default articleTypes;
